import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';

import { find } from "utils/dom"
export function contatoPage() {


const Home = find("[js-page='contato']")
	if (!Home) return

	const contato = new Swiper(".swiper-contato",{
		slidesPerView: 1,

		navigation: {
			nextEl: ".swiper-contato .swiper-button-next",
			prevEl: ".swiper-contato .swiper-button-prev",
		},
		pagination: {
			el: '.swiper-contato .swiper-pagination',
			clickable: true,
		}
	})
}